<template>
  <div>
   <div  class="foot_store" style="background:#fff;padding:10px 0px">
      <van-row v-for="(val,key)  in commodity" :key ='key' style="width:48%;margin-left:7px">
        <van-col span="12" style="width:95%"><van-image width="100%" height="140" radius="5" :src="val.comm_p"/></van-col>
        <van-col span="13"><van-button color="#0081ff" round size="mini" style="font-size:12px">{{val.comm_btn}}</van-button></van-col>
        <van-col span="24"   class="van-ellipsis">{{val.comm_txt}}</van-col>
        <van-col span="8" style="font-size:14px;color:#e03997">{{val.integral}}积分</van-col>
        <van-col span="8" style="color:#0081ff;float:right">{{val.money}}</van-col>
      </van-row>
    </div>
  </div>
</template>
<style lang="scss" scoped>
    .foot_store {
      display: flex;
  }
</style>
<script>
export default {
  data () {
    return {
      commodity: [
        {
          comm_p: 'https://maximum_api.bei-lin.cn/wechat_oa/weida.png',
          comm_btn: '爆品',
          comm_txt: '维达抽纸超韧3层M码120抽24包整箱装',
          integral: 600
        },
        {
          comm_p: 'https://maximum_api.bei-lin.cn/wechat_oa/jinlongyu.png',
          comm_btn: '爆品',
          comm_txt: '金龙鱼 盘锦大米 蟹稻共生5kg',
          integral: 300,
          money: '￥10'
        }
      ]

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inte_store/foot_store.vue